import * as React from 'react';

export interface IFiltersContainerProps {
  children?: React.ReactNode;
}

export const FiltersContainer = (props: IFiltersContainerProps) => <div>{props.children}</div>;
